import { useQuery, UseQueryOptions } from "react-query";
import { IUser, Route } from "@edgetier/watchtower-types";
import { AxiosError } from "axios";
import { getAllPaginatedItems } from "utilities/get-all-paginated-items";

const requestUsers = async (url: string, queryParameters: {}) => {
    const users = await getAllPaginatedItems<IUser>(url, { params: queryParameters });
    return users;
};

const useUsers = <T = IUser[]>(
    queryParameters: {} = {},
    options: Omit<UseQueryOptions<IUser[], AxiosError, T>, "queryKey" | "queryFn"> = {}
) => {
    const url = Route.Users;
    return useQuery<IUser[], AxiosError, T>([url, queryParameters], () => requestUsers(url, queryParameters), options);
};

export default useUsers;
